import { graduationRequests } from "api/graduationApi";
import React from "react";
import { Datagrid, FunctionField, ReferenceField, TextField, useRecordContext } from "react-admin";

const TimeIntervalsExpanded = () => {
  const record = useRecordContext();

  return (
    record?.timeIntervals && (
      <Datagrid
        data={record?.timeIntervals}
        rowClick={false}
        bulkActionButtons={false}
        sx={{
          "& .RaDatagrid-headerCell": {
            textAlign: "left",
          },
        }}
      >
        <FunctionField
          label="Час"
          render={rec => `${rec.from} - ${rec.to}`}
        />
        <ReferenceField
          source="dateType"
          reference={graduationRequests.getScheduleDateTypeSelect()}
          label="Тип дата"
          sortable={false}
        >
          <TextField source="nameBg" />
        </ReferenceField>
      </Datagrid>
    )
  );
};

export default TimeIntervalsExpanded;
